<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'organizationId'
        label= '机构id'
        width= '100'>
      </el-table-column>
      <el-table-column
        prop= 'code'
        label= '土地编码'
        width= '140'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '土地名称'
        width= '160'>
      </el-table-column>
      <el-table-column
        prop= 'ustime'
        label= '使用期限'
        width= '190'>
        <template slot-scope='scope'>
          {{ formatDate(scope.row.ustime) }} 至 {{ formatDate(scope.row.uetime) }}
        </template>
      </el-table-column>
      <el-table-column
        prop= 'gis'
        label= '经纬度坐标信息'>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" top="10px">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="编码" :label-width="formLabelWidth" prop="code">
          <el-input v-model="form.code" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="名称" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="经纬度面积" :label-width="formLabelWidth">
          <div id="container" style="width:100%;height:500px;"></div>
        </el-form-item>
        <el-row>
          <el-col :span="12">
            <el-form-item label="使用期限(始)" :label-width="formLabelWidth" prop="ustime">
              <el-date-picker v-model="form.ustime" type="date" placeholder="开始时间"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="使用期限(尾)" :label-width="formLabelWidth" prop="uetime">
              <el-date-picker v-model="form.uetime" type="date" placeholder="结束时间"></el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="clearGis()">清空经纬度</el-button>
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import AMapLoader from '@amap/amap-jsapi-loader'
import { formatDate } from '../../../util/date'
export default {
  data () {
    return {
      
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        organizationId: null,
        code: null,
        name: null,
        gis: null,
        descr: null,
        ustime: null,
        uetime: null
      },
      rules: {
        organizationId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '机构id 不能为空', trigger: ['change', 'blur'] }],
        code: [{ required: true, message: '土地编码 不能为空', trigger: ['change', 'blur'] }, { required: true, message: '土地编码 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        name: [{ required: true, message: '土地名称 不能为空', trigger: ['change', 'blur'] }, { required: true, message: '土地名称 长度范围:[0,90]', min: 0, max: 90, trigger: ['change', 'blur'] }],
        gis: [{ required: true, message: '经纬度坐标信息 不能为空', trigger: ['change', 'blur'] }],
        ustime: [{ required: true, message: '使用开始时间 不能为空', trigger: ['change', 'blur'] }],
        uetime: [{ required: true, message: '使用结束时间 不能为空', trigger: ['change', 'blur'] }]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      map: null,
      polygon: null,
      organizationId: 0
    }
  },
  created () {
    let userInfo = JSON.parse(localStorage.getItem('userInfo') + '')
    if (userInfo && userInfo.organizationId) {
      this.organizationId = userInfo.organizationId
    }
    this.query()
  },
  mounted () {
  },
  methods: {
    formatDate (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd')
    },
    clearGis () {
      this.map.clearMap()
      this.form.gis = '[]'
      this.initAMap()
    },
    initAMap () {
      let that = this
      let arrayStr = '[]'
      if (that.form.gis) {
        arrayStr = that.form.gis
      }
      let array = JSON.parse(arrayStr)
      AMapLoader.load({
        key: 'b72c573a626158a27e4ada7a9c853665',
        version: '1.4.15',
        plugins: ['AMap.Driving', 'AMap.MapType']
      }).then((AMap) => {
        that.map = new AMap.Map('container', {
          zoom: 17,
          zooms: [2, 22],
          center: [121.101275, 30.690057],
          layers: [
            new AMap.TileLayer.Satellite(),
            new AMap.TileLayer.RoadNet()
          ]
        })
        if (array.length > 2) {
          that.addPolygon([].concat(array), '#000099', AMap)
          let lng = 0
          let lat = 0
          let count = 0
          for (let item of array) {
            lng = lng + item[0]
            lat = lat + item[1]
            count = count + 1
          }
          if (count > 0) {
            lng = lng / count
            lat = lat / count
            if (that.map) {
              that.map.setCenter([lng, lat])
            }
          }
        }
        that.map.on('click', (e) => {
          array.push([e.lnglat.getLng(), e.lnglat.getLat()])
          that.form.gis = JSON.stringify(array)
          that.addPolygon([].concat(array), '#000099', AMap)
        })
      }).catch(e => {
        console.log(e)
      })
    },
    addPolygon (data, areaColor, AMap) {
      let that = this
      console.log(that.form)
      that.map.clearMap()
      if (!data) {
        return
      }
      for (let pos of data) {
        let markerTemp = new AMap.CircleMarker({
          center: pos,
          radius: 2,
          strokeColor: 'white',
          strokeWeight: 2,
          strokeOpacity: 1,
          fillColor: 'rgba(0,0,255,1)',
          fillOpacity: 1,
          zIndex: 10,
          bubble: true,
          cursor: 'pointer',
          clickable: true
        })
        markerTemp.setMap(that.map)
      }
      if (data.length < 3) {
        return
      }
      that.polygon = new AMap.Polygon({
        path: data,
        fillColor: areaColor,
        strokeOpacity: 1,
        fillOpacity: 0.5,
        strokeColor: '#2b8cbe',
        strokeWeight: 1,
        strokeStyle: 'dashed',
        strokeDasharray: [5, 5]
      })
      that.map.add(that.polygon)
    },
    del (row) {
      let that = this
      console.log('del')
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/ground/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      console.log('delClose')
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/ground/listPage?current=${that.current}&pageSize=${that.pageSize}&organizationId=${that.organizationId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
      this.initAMap()
    },
    digAdd () {
      this.form = {}
      this.dialogFormVisible = true
      this.initAMap()
    },
    submitForm (formName) {
      let that = this
      that.form.organizationId = that.organizationId
      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/ground/add'
          if (that.form.id) {
            url = '/ground/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/ground/Index.vue